DealWidgets = window.DealWidgets ?= {}
ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}
ProductReviews.Views.Widget ?= {}

ProductReviews.Views.Widget.ReviewRating = require '../../product_reviews/frontend/views/product_reviews_widget_review_rating'

DealWidgets.lazyLoadImages = ($widgets) ->
  $widgets.find('.lazy-load').each (position, imageElement) ->
    $image = $(imageElement)
    $image.attr 'src', $image.attr('data-original')

DealWidgets.ajax_success = (data, productReviews, done) ->
  unless data?
    $('#featuredtopslot-widget-placeholder').remove()
    $('#bottomslot-widget-placeholder').remove()
    $('#abovereviewsslot-widget-placeholder').remove()
    return done()

  hasWidgets = false
  $featuredTopSlot = $('#featuredtopslot-widget-placeholder')
  $bottomSlot = $('#bottomslot-widget-placeholder')
  $aboveReviewsSlot = $('#abovereviewsslot-widget-placeholder')

  if data.FeaturedTopSlot?.length
    hasWidgets = true
    $featuredTopSlot.replaceWith data.FeaturedTopSlot + "<hr class='dotted-border' id='top-slot-border'/>"
  else
    $featuredTopSlot.remove()

  if data.BottomSlot?.length
    hasWidgets = true
    $bottomSlot.replaceWith data.BottomSlot
  else
    $bottomSlot.remove()

  if data.AboveReviewsSlot?.length
    hasWidgets = true
    $aboveReviewsSlot.replaceWith data.AboveReviewsSlot
  else
    $aboveReviewsSlot.remove()

  if hasWidgets
    Groupon.Utils?.lazyLoadImages?()
    new ProductReviews.Views.Widget.ReviewRating {productReviews}

    if $widgets = $('.mm-widget, .fake-wls-widget .widget-deals')
      WLS.init($widgets.parent())
      DealWidgets.lazyLoadImages($widgets)
      GIG.Utils.truncateElements($widgets)

  done()


DealWidgets.init = ({clientDealWidgets, productReviews}, done) ->
  unless clientDealWidgets?
    new ProductReviews.Views.Widget.ReviewRating {productReviews}

    return done()

  $ ->
    $(window).load ->
      $.ajax
        url      : clientDealWidgets.formattedUrl
        dataType : 'json'
        success  : (data) ->
          DealWidgets.ajax_success data, productReviews, done

        error: (err) ->
          $('#featuredtopslot-widget-placeholder').remove()
          $('#bottomslot-widget-placeholder').remove()
          $('#abovereviewsslot-widget-placeholder').remove()

          done()


module.exports = DealWidgets
